import React from 'react'
import { Link, withPrefix } from 'gatsby'
import { Badge, Card, CardTitle, CardBody } from 'reactstrap'
import Img from 'gatsby-image'
import { slugify } from '../../util/utilityFunctions'

const Post = ({ title, author, slug, date, body, fluid, tags }) => {
    return (
        <Card style={{
            borderRadius: '5%',
            backgroundColor: 'var(--card)',
            boxShadow: '0 0.5rem 1rem var(--cardShadow)',
        }}
        >
            <Link to={withPrefix(`/blog/${slugify(slug)}`)}>
                <Img className="card-img-top" fluid={fluid} alt="gambar" />
            </Link>
            <CardBody>
                <CardTitle>
                    <Link to={withPrefix(`/blog/${slugify(slug)}`)} style={{
                        color: 'var(--textLink)',
                    }}>{title}</Link>
                </CardTitle>
                {tags.map(tag => (
                    <Link to={withPrefix(`blog/tag/${slugify(tag)}`)} key={tag}>
                        <Badge color="primary" className="text-uppercase mr-2">{tag}</Badge>
                    </Link>
                ))}
                <br />
            </CardBody>
        </Card>
    )
}

export default Post